export default __webpack_public_path__ + "static/media/bl_harrisia.ad663d30.png";